(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["casekaro-collection-tag-filter"] && !Shopify.designMode) return;
  try {
    function initCollectionTagFilters(scope) {
    scope.querySelectorAll('[data-tag-filter]').forEach(function (filter) {
      if (filter.dataset.initialized === 'true') return;

      var rail = filter.querySelector('.ck-tag-filter__rail');
      var previous = filter.querySelector('.ck-tag-filter__arrow--previous');
      var next = filter.querySelector('.ck-tag-filter__arrow--next');
      if (!rail || !previous || !next) return;

      filter.dataset.initialized = 'true';

      function updateArrows() {
        previous.disabled = rail.scrollLeft <= 1;
        next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 1;
      }

      function scrollRail(direction) {
        var behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        rail.scrollBy({ left: direction * 260, behavior: behavior });
      }

      previous.addEventListener('click', function () { scrollRail(-1); });
      next.addEventListener('click', function () { scrollRail(1); });
      rail.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      filter.querySelectorAll('img').forEach(function (image) {
        image.addEventListener('load', updateArrows, { once: true });
      });
      updateArrows();
    });
  }

  initCollectionTagFilters(document);
  document.addEventListener('shopify:section:load', function (event) {
    initCollectionTagFilters(event.target);
  });
  } catch(e) { console.error(e); }
})();

})();
